


// Generated from io.spcfy.orders.samplemeta.enums.CollectionType

export type CollectionTypeKey =
  "SOIL_CORE_SAMPLING" |
  "SEDIMENT_SAMPLING" |
  "WATER_FILTRATION" |
  "PASSIVE_EDNA_SAMPLER" |
  "AIR_FILTER_SAMPLING" |
  "SURFACE_SWABBING" |
  "FECAL_COLLECTION" |
  "PLANT_WASH_SAMPLING" |
  "SNOW_EDNA_SAMPLING" |
  "RAINWATER_SAMPLING" |
  "BIOFILM_SCRAPING" |
  "EPILITHIC_BIOFILM_SAMPLING" |
  "LEAF_LITTER_SIFTING" |
  "BARK_SCRAPING" |
  "ROOT_ZONE_SAMPLING" |
  "RHIZOSPHERE_SAMPLING";


export interface CollectionTypeDTO {
  key: CollectionTypeKey;
  label: string;    
}


export const CollectionTypes: Record<CollectionTypeKey, CollectionTypeDTO> = {
  SOIL_CORE_SAMPLING: { key: "SOIL_CORE_SAMPLING", label: "Soil core sampling" },
  SEDIMENT_SAMPLING: { key: "SEDIMENT_SAMPLING", label: "Sediment sampling" },
  WATER_FILTRATION: { key: "WATER_FILTRATION", label: "Water filtration" },
  PASSIVE_EDNA_SAMPLER: { key: "PASSIVE_EDNA_SAMPLER", label: "Passive eDNA sampler" },
  AIR_FILTER_SAMPLING: { key: "AIR_FILTER_SAMPLING", label: "Air filter sampling" },
  SURFACE_SWABBING: { key: "SURFACE_SWABBING", label: "Surface swabbing" },
  FECAL_COLLECTION: { key: "FECAL_COLLECTION", label: "Fecal collection" },
  PLANT_WASH_SAMPLING: { key: "PLANT_WASH_SAMPLING", label: "Plant wash sampling" },
  SNOW_EDNA_SAMPLING: { key: "SNOW_EDNA_SAMPLING", label: "Snow eDNA sampling" },
  RAINWATER_SAMPLING: { key: "RAINWATER_SAMPLING", label: "Rainwater sampling" },
  BIOFILM_SCRAPING: { key: "BIOFILM_SCRAPING", label: "Biofilm scraping" },
  EPILITHIC_BIOFILM_SAMPLING: { key: "EPILITHIC_BIOFILM_SAMPLING", label: "Epilithic biofilm sampling" },
  LEAF_LITTER_SIFTING: { key: "LEAF_LITTER_SIFTING", label: "Leaf litter sifting" },
  BARK_SCRAPING: { key: "BARK_SCRAPING", label: "Bark scraping" },
  ROOT_ZONE_SAMPLING: { key: "ROOT_ZONE_SAMPLING", label: "Root zone sampling" },
  RHIZOSPHERE_SAMPLING: { key: "RHIZOSPHERE_SAMPLING", label: "Rhizosphere sampling" }
};
